<template>
<div>
	<b-navbar class="submenu">
		<b-container>
			<b-navbar-brand href="#">CMS Administration</b-navbar-brand>
			<b-collapse id="nav-collapse-sub" is-nav>
				<b-navbar-nav>
					<a href="#" @click="newArticle()">New Article</a>
					<a href="#" @click="saveArticle()" v-if="article">Save</a>
					<a href="#" @click="deleteSelected()" v-if="article">Delete</a>
					<a href="#" @click="onLoad()" v-if="article">Reload</a>
				</b-navbar-nav>
			</b-collapse>
		</b-container>
	</b-navbar>
	<div id="content">
		<b-modal id="modMessage" hide-backdrop content-class="shadow" header-bg-variant="dark" header-text-variant="light" title="CMS Admin">
			<p class="my-4">{{message}}</p>
		</b-modal>
		<b-modal id="modSure" hide-backdrop content-class="shadow" header-bg-variant="dark" header-text-variant="light" title="Really?">
			<p class="my-4">Are you sure?</p>
			<template #modal-footer="{ ok, cancel }">
				<b-button variant="success" @click="doDeleteSelected()">Yes</b-button>
				<b-button variant="danger" @click="cancel()">No</b-button>
			</template>
		</b-modal>

		<div class="row">
		<!--
			<b-alert show variant="success" v-if="message"><b-icon-info  font-scale="1.5"/> {{message}}</b-alert>
			<b-alert show variant="danger" v-if="error">{{error}}</b-alert>
		-->
			<div class="col-md-3 mb-4">
				<b-form-input placeholder="search" class="mb-2" v-model="search"></b-form-input>
				<div class="leftSide">
					<b-table striped hover :filter="search" :items="articles" :fields="[{key: 'title', label: 'Article'}, 'app']" selectable select-mode="single" @row-clicked="selectArticle"></b-table>
				</div>
			</div>
			<div class="col-md-9" v-if="article">
				<div class="m-5 mt-0">
					<h2>{{article.title}}</h2>
					<div class="mb-2"><small>ID: {{article.id}}</small></div>
					<div class="row">
						<div class="col-md-6">
							Article Title: <b-form-input class="mb-2" v-model="article.title"></b-form-input>
						</div>
						<div class="col-md-4">
							Author: <b-form-input class="mb-2" v-model="article.author"></b-form-input>
						</div>
						<div class="col-md-1">
							App: <b-form-checkbox class="mb-2" v-model="article.app"></b-form-checkbox>
						</div>
						<div class="col-md-1">
							Web: <b-form-checkbox class="mb-2" v-model="article.web"></b-form-checkbox>
						</div>
					</div>
					Tags: <b-form-input class="mb-2" v-model="article.tags"></b-form-input>
					Short Summary: <b-form-textarea rows="4" class="mb-2" v-model="article.shortSummary"></b-form-textarea>
					Body: <b-form-textarea rows="12" class="mb-2" v-model="article.body"></b-form-textarea>
					<i class="pb-2" style="clear:both">{{wordCount()}} word(s)</i><br/><br/>
					Key: 
					<ul>
						<li><small>Can leave blank, will autogenerate from title</small> </li>
						<li><small>Copy and paste this for CMS page links in app e.g from a move</small> </li>
						<li><small>Must be unique!!</small> </li>
					</ul>
					<b-form-input class="mb-2" v-model="article.key"></b-form-input>
					Icon Image (Full URL, leave bank for no image):<br/>
					<b-form-select class="mb-2" v-model="article.iconImage">
						<option value="http://content.sysodev.link/img/CMS_Thumb_Credit.svg">Credit (Arrow Up)</option>
						<option value="http://content.sysodev.link/img/CMS_Thumb_Investment_Plant.svg">Plant</option>
						<option value="http://content.sysodev.link/img/CMS_Thumb_Investments_Tree.svg">Tree</option>
						<option value="http://content.sysodev.link/img/CMS_Thumb_Savings_Umbrella.svg">Umbrella</option>
						<option value="http://content.sysodev.link/img/CMS_Thumb_Spending_Budget.svg">Budget (Cocktail Glass)</option>
						<option value="http://content.sysodev.link/img/CMS_Thumb_Support.svg">Support (Septic Peg Hands)</option>
					</b-form-select>
					<b-form-input class="mb-2" v-model="article.iconImage"></b-form-input>
					<b-img class="mb-2" width="200" thumbnail :src="article.iconImage"></b-img>
					<br/><br/>
					Image (Full URL, leave bank for no image):<br/>
					<b-form-select class="mb-2" v-model="article.image">
						<option value="http://content.sysodev.link/img/CMS_Articles_Credit.svg">Credit (Arrow Up)</option>
						<option value="http://content.sysodev.link/img/CMS_Articles_Investments-Tree.svg">Tree</option>
						<option value="http://content.sysodev.link/img/CMS_Articles_Investments.svg">Plant</option>
						<option value="http://content.sysodev.link/img/CMS_Articles_Saving.svg">Umbrella</option>
						<option value="http://content.sysodev.link/img/CMS_Articles_Spending Plan.svg">Budget (Cocktail Glass)</option>
						<option value="http://content.sysodev.link/img/CMS_Articles_Support.svg">Support (Septic Peg Hands)</option>
					</b-form-select>
					<b-form-input class="mb-2" v-model="article.image"></b-form-input>
					<b-img class="mb-2" width="200" thumbnail :src="article.image"></b-img>
					<br/><br/>
				</div>
			</div>
		<!--
			<b-alert show variant="success" v-if="message" class="mt-2">{{message}}</b-alert>
			<b-alert show variant="danger" v-if="error" class="mt-2">{{error}}</b-alert>
		-->
		</div>
	</div>
</div>
</template>
<script>
export default {
  name: 'CMS',
  data() {
	return{
		articles: null,
		article: null,
		message: null,
		error: null,
		search: ""
	}
  },
  methods: {
	getArticles: function(autoSelect){
		this.$http.get(this.$config.ApiUri + "/CMS/Articles?forWeb=false&forApp=false")
			.then((result) => {
				this.articles = result.data;
				if(autoSelect) {
					if (this.articles.length > 0) {
						this.article = this.articles[0];
					}
				}
			}
		)
	},
	wordCount: function() {
		if (this.article == null || this.article.body == null) { return 0; }
		return this.article.body.split(' ').length;
	},
	selectArticle: function(a) {
		this.article = a;
	},
	saveArticle: function(){
		if (this.article.tags == null || this.article.tags == "") {
			this.showMessage("Please enter some tags"); return;
		}
		if (this.article.id != null) {
			this.$http.put(this.$config.ApiUri + "/CMS/Articles/" + this.article.id, this.article)
				.then(() => {
					this.getArticles(false);
					this.showMessage("Article saved OK!");
				}
			).catch((e) => { 
				console.log(e.response);
				this.showError(e.response.status + e.response.data); });
		}
		else {
			this.$http.post(this.$config.ApiUri + "/CMS/Articles", this.article)
				.then((result) => {
					this.article = result.data;
					this.getArticles(false);
					this.showMessage("Article created OK!");
				}
			).catch((e) => { 
				console.log(e);
				this.showError(e.response.status + e.response.data); });
		}
	},
	deleteSelected() {
		this.$bvModal.show('modSure');
	},
	doDeleteSelected() {
		this.$bvModal.hide('modSure');
		this.$http.delete(this.$config.ApiUri + "/CMS/Articles/" + this.article.id)
			.then(() => {
				this.article = null;
				this.getArticles(true);
				this.showMessage("Article deleted OK!");
			}
		).catch(() => { this.showError(); });
	},
	newArticle() {
		this.article = { "id": null, "title": "", "body": "", "author": "", "shortSummary" : "", "iconImage" : "",  "image" : "", "tags": "", "app": true, "web": false };
	},
	showMessage(message) {
		this.message=message;
		this.$bvModal.show('modMessage');
		setTimeout(() => this.$bvModal.hide('modMessage'), 3000);
	},
	showError(message) {
		if (!message) { message = "Sorry, that didn't work, please contact Tris"; }
		this.message=message;
		this.$bvModal.show('modMessage');
		setTimeout(() => this.$bvModal.hide('modMessage'), 3000);
	},
	onLoad() {
		this.getArticles(true);
	}
  },
  mounted: function() { this.onLoad(); }
}
</script>

<style>
.modal-header .close {
  display:none;
}
.leftSide
{
	height: 600px;
	overflow: scroll;
	overflow-x: hidden;
}
</style>